import React, { useState } from "react";
import { Controller } from "react-hook-form";
import { Button, Flex } from "@chakra-ui/react";
import { ViewIcon, EditIcon, ExternalLinkIcon } from "@chakra-ui/icons";
import "./pdfEditor.css";

const PdfEditor = ({ name, control, defaultValue = "", onTestPdf }) => {
  const [showPreview, setShowPreview] = useState(false);

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      render={({ field }) => (
        <div className="pdf-editor">
          <Flex justify="flex-end" gap={2} mb="6px">
            <Button
              type="button"
              size="sm"
              colorScheme="blue"
              variant={showPreview ? "solid" : "outline"}
              leftIcon={showPreview ? <EditIcon /> : <ViewIcon />}
              onClick={() => setShowPreview((v) => !v)}
            >
              {showPreview ? "Edit" : "Preview"}
            </Button>
            {onTestPdf && (
              <Button
                type="button"
                size="sm"
                colorScheme="blue"
                variant="outline"
                leftIcon={<ExternalLinkIcon />}
                onClick={onTestPdf}
              >
                Test PDF
              </Button>
            )}
          </Flex>
          {showPreview ? (
            <iframe
              className="pdf-editor__preview-iframe"
              srcDoc={field.value || ""}
              title="PDF Preview"
              sandbox="allow-same-origin"
            />
          ) : (
            <textarea
              className="pdf-editor__textarea"
              value={field.value || ""}
              onChange={(e) => field.onChange(e.target.value)}
              spellCheck={false}
            />
          )}
        </div>
      )}
    />
  );
};

export default PdfEditor;
